import { useRef, useEffect } from "react";
import { localStorageService } from "./local-storage.service";
import { IUser, IAddress, IClub } from "@eagerdog/interfaces";
import { IOption } from "../components/Dropdown/Dropdown";
import { Constants } from "@eagerdog/constants";
import moment from "moment-timezone";

import dog1 from "../assets/ren_450x450.png";
import dog2 from "../assets/raeah_450x450.png";
import dog3 from "../assets/stan_450x450.png";
import dog4 from "../assets/kai_450x450.png";
import dog5 from "../assets/rumor_450x450.png";
import dog6 from "../assets/siri_450x450.png";
import dog7 from "../assets/dog7_450x450.png";
import dog8 from "../assets/dog8_450x450.png";
import dog9 from "../assets/dog9_450x450.png";
import dog10 from "../assets/dog10_450x450.png";
import dog11 from "../assets/dog11_450x450.png";
import dog12 from "../assets/dog12_450x450.png";
import dog13 from "../assets/dog13_450x450.png";
import dog14 from "../assets/dog14_450x450.png";
import dog15 from "../assets/dog15_450x450.png";
import dog16 from "../assets/dog16_450x450.png";
import dog17 from "../assets/dog17_450x450.png";
import dog18 from "../assets/dog18_450x450.png";
import dog19 from "../assets/dog19_450x450.png";
import dog20 from "../assets/dog20_450x450.png";
import dog21 from "../assets/dog21_450x450.png";
import dog22 from "../assets/dog22_450x450.png";
import dog23 from "../assets/dog23_450x450.png";
import dog24 from "../assets/dog24_450x450.png";
import dog25 from "../assets/dog25_450x450.png";
import dog26 from "../assets/dog26_450x450.png";
import dog27 from "../assets/dog27_450x450.png";
import dog28 from "../assets/dog28_450x450.png";
import dog29 from "../assets/dog29_450x450.png";


export interface IEventRegisterInput {
  id?: string;
  type: string;
  flex?: number;
  dropUp?: boolean;
  defaultValue?: string;
  multiSelect?: boolean;
  label: string;
  options: IOption[];
  elementType?: "show_element" | "level" | "section";
  showElement?: string;
  // Fixed section applied to every class created from this input (C-WAGS FEO rows:
  // label stays the real show_element, options' id is the real level, section = "FEO").
  section?: string;
  // Optional header text when it must differ from `label` (e.g. "Scent FEO" while label is "Scent")
  displayLabel?: string;
  mutuallyExclusive?: string[][];
  multiClassMessages?: { [key: string]: string };
  multiLevelWarning?: string;
  columnLayout?: boolean;
}

export interface IEventRegisterRow {
  allowDuplicates?: boolean;
  skip?: boolean;
  inputs: IEventRegisterInput[];
}

export interface IDogPortrait {
  image: string;
  name: string;
}

export interface IShowType {
  name: string;
  disabled: boolean;
}

export const dogHeightTypes: IOption[] = [
  { id: "None", value: "None" },
  {
    id: Constants.jump_height_type.minimum,
    value: Constants.jump_height_type.minimum,
  },
  {
    id: Constants.jump_height_type.standard,
    value: Constants.jump_height_type.standard,
  },
];

export const dogRallyHeights: IOption[] = [
  { id: "4", value: '4"' },
  { id: "8", value: '8"' },
  { id: "12", value: '12"' },
  { id: "16", value: '16"' },
];

export const dogObedienceHeights: IOption[] = [
  { id: "4", value: '4"' },
  { id: "6", value: '6"' },
  { id: "8", value: '8"' },
  { id: "10", value: '10"' },
  { id: "12", value: '12"' },
  { id: "14", value: '14"' },
  { id: "16", value: '16"' },
  { id: "18", value: '18"' },
  { id: "20", value: '20"' },
  { id: "22", value: '22"' },
  { id: "24", value: '24"' },
  { id: "26", value: '26"' },
  { id: "28", value: '28"' },
  { id: "30", value: '30"' },
];

// CKC Obedience Trial Rules 8.21.1: high jump adjusts in 1" increments from 4" to 36"
export const ckcObedienceHeights: IOption[] = Array.from({ length: 33 }, (_, i) => {
  const inches = (i + 4).toString();
  return { id: inches, value: `${inches}"` };
});

// CKC Rally Obedience Trial Rules 8.18.4(b): four jump heights by height at the withers, no breed or age exceptions
export const ckcRallyHeights: IOption[] = [
  { id: "6", value: '6"' },
  { id: "8", value: '8"' },
  { id: "12", value: '12"' },
  { id: "16", value: '16"' },
];

export const dogAgilityHeights: IOption[] = [
  { id: "4", value: '4"' },
  { id: "6", value: '6"' },
  { id: "8", value: '8"' },
  // { id: "10", value: '10"' },
  { id: "12", value: '12"' },
  { id: "16", value: '16"' },
  { id: "20", value: '20"' },
  { id: "24", value: '24"' },
  { id: "26", value: '26"' },
];

export const nonLicensed: string[] = [
  Constants.dog_class_element.novice_puppy,
  Constants.dog_class_element.veteran,
  Constants.dog_class_element.brood_bitch_stud_dog,
  Constants.dog_class_element.brace,
  Constants.dog_class_element.total_dog,
  //Constants.dog_class_element.abi_best_of_breed, //DO temporary commented out
  Constants.dog_class_element.abi_bred_by_exibitor,
  Constants.dog_class_element_level.akc_futurity,
  Constants.dog_class_element_level.akc_sled_dog,
  Constants.dog_class_element_level.akc_hunting_class,
  Constants.dog_class_element_level.akc_field_trial_class,
  Constants.dog_class_element_level.akc_teams,
  Constants.dog_class_element_level.akc_parade_of_titleholders,
  Constants.dog_class_element_level.akc_coursing,
  Constants.dog_class_element_level.akc_best_head,
  Constants.dog_class_element_level.akc_best_movement,
  Constants.dog_class_element_level.akc_best_field,
  Constants.dog_class_element_level.akc_junior_showmanship,
  // REMOVED: akc_puppy_sweepstakes is deprecated - use age-specific classes instead
  Constants.dog_class_element_level.akc_puppy_sweepstakes_6_9,
  Constants.dog_class_element_level.akc_puppy_sweepstakes_9_12,
  Constants.dog_class_element_level.akc_puppy_sweepstakes_12_18,
  Constants.dog_class_element_level.akc_puppy_sweepstakes_12_15,
  Constants.dog_class_element_level.akc_puppy_sweepstakes_15_18,
  Constants.dog_class_element_level.akc_puppy_sweepstakes_bred_by_exhibitor_6_18,
  Constants.dog_class_element_level.akc_puppy_sweepstakes_18_24,
  Constants.dog_class_element_level.akc_dual_title_sweepstakes_6m_7y,
  Constants.dog_class_element_level.akc_dual_title_sweepstakes_7y_plus,
  Constants.dog_class_element_level.akc_dual_title_sweepstakes_7y_11y,
  Constants.dog_class_element_level.akc_dual_title_sweepstakes_10y_plus,
  Constants.dog_class_element_level.akc_dual_title_sweepstakes_11y_plus,
  Constants.dog_class_element.junior_showmanship,
  Constants.dog_class_element_level.total_junior,
  Constants.dog_class_element_level.fun_run,
  Constants.dog_class_element_level.puppy_dash,
  Constants.dog_class_element_level.abi_baby_puppy,
  Constants.dog_class_element.abi_stud_dog,
  Constants.dog_class_element.abi_brood_bitch,
  Constants.dog_class_element.abi_star,
  Constants.dog_class_element_level.isws_brace,
  Constants.dog_class_element_level.isws_stud_dog,
  Constants.dog_class_element_level.isws_brood_bitch,
];

export const separatePricedElements: string[] = [
  Constants.dog_class_element.novice_puppy,
  Constants.dog_class_element.veteran,
  Constants.dog_class_element.brood_bitch_stud_dog,
  Constants.dog_class_element.brace,
  Constants.dog_class_element.total_dog,
  //Constants.dog_class_element.abi_best_of_breed,
  Constants.dog_class_element.abi_bred_by_exibitor,
  Constants.dog_class_element_level.akc_futurity,
  Constants.dog_class_element_level.akc_sled_dog,
  Constants.dog_class_element_level.akc_hunting_class,
  Constants.dog_class_element_level.akc_field_trial_class,
  Constants.dog_class_element_level.akc_teams,
  Constants.dog_class_element_level.akc_parade_of_titleholders,
  Constants.dog_class_element_level.akc_coursing,
  Constants.dog_class_element_level.akc_best_head,
  Constants.dog_class_element_level.akc_best_movement,
  Constants.dog_class_element_level.akc_best_field,
  Constants.dog_class_element_level.akc_junior_showmanship,
  // REMOVED: akc_puppy_sweepstakes is deprecated - use age-specific classes instead
  Constants.dog_class_element_level.akc_puppy_sweepstakes_6_9,
  Constants.dog_class_element_level.akc_puppy_sweepstakes_9_12,
  Constants.dog_class_element_level.akc_puppy_sweepstakes_12_18,
  Constants.dog_class_element_level.akc_puppy_sweepstakes_12_15,
  Constants.dog_class_element_level.akc_puppy_sweepstakes_15_18,
  Constants.dog_class_element_level.akc_puppy_sweepstakes_bred_by_exhibitor_6_18,
  Constants.dog_class_element_level.akc_puppy_sweepstakes_18_24,
  Constants.dog_class_element_level.akc_dual_title_sweepstakes_6m_7y,
  Constants.dog_class_element_level.akc_dual_title_sweepstakes_7y_plus,
  Constants.dog_class_element_level.akc_dual_title_sweepstakes_7y_11y,
  Constants.dog_class_element_level.akc_dual_title_sweepstakes_10y_plus,
  Constants.dog_class_element_level.akc_dual_title_sweepstakes_11y_plus,
  Constants.dog_class_element.junior_showmanship,
  Constants.dog_class_element_level.total_junior,
  Constants.dog_class_element.scentwork_container,
  Constants.dog_class_element.scentwork_interior,
  Constants.dog_class_element.scentwork_exterior,
  Constants.dog_class_element.scentwork_buried,
  Constants.dog_class_element.scentwork_handler_disc,
  Constants.dog_class_element.scentwork_detective,
  Constants.dog_class_element.abi_stud_dog,
  Constants.dog_class_element.abi_brood_bitch,
  Constants.dog_class_element.abi_star,
  Constants.dog_class_element_level.isws_brace,
  Constants.dog_class_element_level.isws_stud_dog,
  Constants.dog_class_element_level.isws_brood_bitch,
];

export namespace helperService {
  export const showTypes: IShowType[] = [
    { name: "Conformation", disabled: true },
    { name: "Nosework", disabled: false },
    { name: "Dock Jumping", disabled: true },
    { name: "Rally Obedience", disabled: true },
    { name: "Weight Pull", disabled: true },
    { name: "Obedience", disabled: true },
    { name: "Agility", disabled: true },
    { name: "Lure Coursing", disabled: true },
  ];

  // Pull every zone IANA associates with the US or Canada, instead of a
  // hand-picked handful of major cities - this surfaces zones like Hawaii,
  // Puerto Rico, and the various Alaska/Yukon/Nunavut/rural Indiana zones
  // that the old city-name filter silently excluded. "America/Panama"
  // shares Regina/Phoenix's exact rule set and gets tagged under CA in
  // IANA's country list for that reason, but it's not a real CA/US option.
  export const usCanadaTimezones: string[] = Array.from(
    new Set([...moment.tz.zonesForCountry("US"), ...moment.tz.zonesForCountry("CA")])
  ).filter(tz => tz !== "America/Panama");

  // IANA only keeps one zone per set of DST rules (e.g. Dallas and Nashville
  // both follow the exact same rules as Chicago, so there's no separate
  // "America/Dallas" zone to add) - these labels call out extra recognizable
  // cities so users don't have to know which city IANA happens to use as
  // that zone's representative.
  const timezoneCityLabels: Record<string, string> = {
    "America/New_York": "New York, Atlanta, Boston, Philadelphia, Washington DC",
    "America/Detroit": "Detroit",
    "America/Kentucky/Louisville": "Louisville, KY",
    "America/Kentucky/Monticello": "Monticello, KY",
    "America/Indiana/Indianapolis": "Indianapolis",
    "America/Indiana/Vincennes": "Vincennes, IN",
    "America/Indiana/Winamac": "Winamac, IN",
    "America/Indiana/Marengo": "Marengo, IN",
    "America/Indiana/Petersburg": "Petersburg, IN",
    "America/Indiana/Vevay": "Vevay, IN",
    "America/Indiana/Tell_City": "Tell City, IN",
    "America/Indiana/Knox": "Knox, IN",
    "America/Toronto": "Toronto, Ottawa, Montreal, Quebec City",
    "America/Chicago": "Chicago, Dallas, Houston, Nashville, Kansas City, Minneapolis, Milwaukee",
    "America/Menominee": "Menominee, MI",
    "America/North_Dakota/Center": "Center, ND",
    "America/North_Dakota/New_Salem": "New Salem, ND",
    "America/North_Dakota/Beulah": "Beulah, ND",
    "America/Winnipeg": "Winnipeg",
    "America/Regina": "Regina, Saskatoon",
    "America/Swift_Current": "Swift Current, SK",
    "America/Denver": "Denver, Salt Lake City, Albuquerque, El Paso",
    "America/Boise": "Boise",
    "America/Edmonton": "Edmonton, Calgary",
    "America/Phoenix": "Phoenix, Tucson",
    "America/Los_Angeles": "Los Angeles, Seattle, San Francisco, San Diego, Las Vegas",
    "America/Vancouver": "Vancouver, Victoria",
    "America/Anchorage": "Anchorage, Fairbanks",
    "America/Juneau": "Juneau",
    "America/Sitka": "Sitka",
    "America/Metlakatla": "Metlakatla",
    "America/Yakutat": "Yakutat",
    "America/Nome": "Nome",
    "America/Adak": "Adak",
    "Pacific/Honolulu": "Honolulu",
    "America/Halifax": "Halifax",
    "America/Moncton": "Moncton",
    "America/Glace_Bay": "Glace Bay, NS",
    "America/Goose_Bay": "Goose Bay, NL",
    "America/Puerto_Rico": "Puerto Rico",
    "America/St_Johns": "St. John's",
    "America/Whitehorse": "Whitehorse",
    "America/Dawson": "Dawson City, YT",
    "America/Dawson_Creek": "Dawson Creek, BC",
    "America/Fort_Nelson": "Fort Nelson, BC",
    "America/Creston": "Creston, BC",
    "America/Atikokan": "Atikokan, ON",
    "America/Blanc-Sablon": "Blanc-Sablon, QC",
    "America/Iqaluit": "Iqaluit, NU",
    "America/Cambridge_Bay": "Cambridge Bay, NU",
    "America/Rankin_Inlet": "Rankin Inlet, NU",
    "America/Resolute": "Resolute, NU",
    "America/Inuvik": "Inuvik, NT",
  };

  // Standard (winter/non-DST) UTC offset in minutes uniquely identifies each
  // North American time zone "family" - e.g. every zone below is some
  // flavor of Mountain Time whether or not it currently observes DST.
  const timezoneFamilyByStandardOffset: Record<number, string> = {
    [-600]: "Hawaii-Aleutian Time",
    [-540]: "Alaska Time",
    [-480]: "Pacific Time",
    [-420]: "Mountain Time",
    [-360]: "Central Time",
    [-300]: "Eastern Time",
    [-240]: "Atlantic Time",
    [-210]: "Newfoundland Time",
  };

  const deriveCityLabel = (tz: string): string => {
    const parts = tz.split("/").slice(1);
    if (parts.length === 0) return tz;
    return parts.reverse().map(p => p.replace(/_/g, " ")).join(", ");
  };

  const buildTimezoneOption = (tz: string): IOption => {
    const year = moment().year();
    const janOffset = moment.tz(`${year}-01-15`, tz).utcOffset();
    const julOffset = moment.tz(`${year}-07-15`, tz).utcOffset();
    const standardOffset = Math.min(janOffset, julOffset);
    const observesDst = janOffset !== julOffset;
    const family = timezoneFamilyByStandardOffset[standardOffset];
    const familyLabel = family ? `${family}${observesDst ? "" : " (no DST)"}` : "";
    const city = timezoneCityLabels[tz] || deriveCityLabel(tz);
    const currentOffset = moment.tz(tz).format("Z");
    const label = [familyLabel, city].filter(Boolean).join(" - ");
    return { id: tz, value: `${label} (UTC${currentOffset})` };
  };

  export const getTimezoneLabel = (tz?: string): string => {
    if (!tz) return "";
    return buildTimezoneOption(tz).value;
  };

  export const usCanadaTimezoneOptions: IOption[] = usCanadaTimezones
    .map(buildTimezoneOption)
    .sort((a, b) => moment.tz(a.id).utcOffset() - moment.tz(b.id).utcOffset() || a.value.localeCompare(b.value));

  export const allDogs: IDogPortrait[] = [
    { image: dog1, name: "Ren" },
    { image: dog2, name: "Raeah" },
    { image: dog3, name: "Stan" },
    { image: dog4, name: "Kai" },
    { image: dog5, name: "Rumor" },
    { image: dog6, name: "Siri" },
    { image: dog7, name: "Dog 7" },
    { image: dog8, name: "Dog 8" },
    { image: dog9, name: "Dog 9" },
    { image: dog10, name: "Dog 10" },
    { image: dog11, name: "Dog 11" },
    { image: dog12, name: "Dog 12" },
    { image: dog13, name: "Dog 13" },
    { image: dog14, name: "Dog 14" },
    { image: dog15, name: "Dog 15" },
    { image: dog16, name: "Dog 16" },
    { image: dog17, name: "Dog 17" },
    { image: dog18, name: "Dog 18" },
    { image: dog19, name: "Dog 19" },
    { image: dog20, name: "Dog 20" },
    { image: dog21, name: "Dog 21" },
    { image: dog22, name: "Dog 22" },
    { image: dog23, name: "Dog 23" },
    { image: dog24, name: "Dog 24" },
    { image: dog25, name: "Dog 25" },
    { image: dog26, name: "Dog 26" },
    { image: dog27, name: "Dog 27" },
    { image: dog28, name: "Dog 28" },
    { image: dog29, name: "Dog 29" },
  ];

  export const formatAddress = (address: IAddress) => {
    let result: string = "";

    if (address.line1) {
      result += address.line1 + ", ";
    }

    if (address.line2) {
      result += address.line2 + ", ";
    }

    if (address.city) {
      result += address.city + ", ";
    }

    if (address.state) {
      result += address.state + ", ";
    }

    if (address.country) {
      result += address.country;
    }

    return result;
  }

  // Clubs/secretaries often type website URLs without a protocol (e.g.
  // "www.hotel.com"). Without one, `<a href>`/`window.open` treat it as a
  // relative path on our own domain and 404. Also repair "https//" (missing
  // colon) and accidental double schemes from prefixing http:// onto https://.
  export const normalizeUrl = (url?: string): string | undefined => {
    if (!url) return undefined;
    let trimmed = url.trim();
    if (!trimmed) return undefined;

    trimmed = trimmed.replace(/^(https?)\/\//i, "$1://");
    trimmed = trimmed.replace(/^(https?:\/\/)+(https?:\/\/)/i, "$2");

    return /^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  };

  export const topDogs: IDogPortrait[] = (() => {
    const shuffled = [...helperService.allDogs].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 2);
  })();

  export const bottomDogs: IDogPortrait[] = (() => {
    const shuffled = [...helperService.allDogs].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 3);
  })();

  export const timeSlotShows: string[] = [
    Constants.show_type.fast_cat,
    Constants.show_type.fast_dash,
    Constants.show_type.cat,
    Constants.show_type.fetch,
    Constants.show_type.obedience_show_n_go,
    Constants.show_type.general_rally,
  ];

  export const timeslotDurationOptions: IOption[] = [
    { id: "5",  value: "5 minutes"  },
    { id: "10", value: "10 minutes" },
    { id: "15", value: "15 minutes" },
    { id: "20", value: "20 minutes" },
    { id: "30", value: "30 minutes" },
    { id: "45", value: "45 minutes" },
    { id: "60", value: "60 minutes" },
  ];

  export const getEventStatus = (status: string) => {
    let statusText: string = "";

    if (!status) {
      return "Upcoming";
    }

    switch (status.toLowerCase()) {
      case Constants.event_status.published:
        statusText = "Live";
        break;
      case Constants.event_status.draft:
        statusText = "Draft";
        break;
      case Constants.event_status.upcoming:
        statusText = "Upcoming";
        break;
      case Constants.event_status.complete:
        statusText = "Closed";
        break;
      case Constants.event_status.archived:
        statusText = "Archived";
        break;
      default:
        statusText = "Upcoming";
        break;
    }

    return statusText;
  };

  export const getDateTimeWithTimezone = (timezone: string, datetime: Date) => {
    const mInEventTz = moment.tz(datetime, 'UTC').tz(timezone);
    return new Date(mInEventTz.year(), mInEventTz.month(), mInEventTz.date(), mInEventTz.hour(), mInEventTz.minute());
  };

  export const usePrevious = (value: any) => {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    });

    return ref.current;
  };

  export const formatTime = (d: Date) => {
    let hours: number = d.getHours();
    let minutes: string | number = d.getMinutes();
    let ampm: string | number = hours >= 12 ? "pm" : "am";

    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;

    let strTime: string = hours + ":" + minutes + " " + ampm;
    return strTime;
  };

  export const setDateInTimezone = (
    timezone?: string,
    inputDate?: Date | string,
    withWeekday: boolean = false, 
  ): string => {
    if (!inputDate) return "";
  
    const date = new Date(inputDate);
  
    return new Intl.DateTimeFormat("en-US", {
      timeZone: timezone || "America/Toronto",
      weekday: withWeekday ? "long" : undefined,
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(date);
  };

  export const hasAdmin = (id: string) => {
    const user = getUser();

    // Club managers are admins only for their own active club context.
    if (user.user_type === Constants.user_type.club_manager) {
      const currentClub = getClub();
      return !!currentClub?._id && currentClub._id === id;
    }

    // For dog owners, require admin capacity for this specific club.
    const capacities = JSON.parse(localStorageService.getItem("capacities") || "[]");
    if (!Array.isArray(capacities) || capacities.length === 0) {
      return false;
    }

    return capacities.some(
      (c: any) => c.club_id === id && (c.capacities || []).includes("admin")
    );
  }

  export const isLoggedIn = () => {
    if (
      localStorageService.getItem("user") &&
      localStorageService.getItem("access_token")
    ) {
      return true;
    }

    return false;
  };

  export const isValidEmail = (email: string) => {
    var regex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}/gm;

    return new RegExp(regex).test(email);
  };

  export const getClub = () => {
    const clubString = localStorageService.getItem("club");

    let club:IClub = {
      _id: "",
      club_name: "",
      address: {},
      email: "",
      phone: ""
    };

    if (clubString) {
      club = JSON.parse(clubString);
    }

    return club;
  };

  export const getCapacities = () => {
    const capacityString = localStorageService.getItem("capacities");

    let capacities:any[] = [];

    if (capacityString) {
      capacities = JSON.parse(capacityString);
    }

    return capacities;
  };

  /** 950 → "950", 2400 → "2.4K", 1200000 → "1.2M" — for follower and like counts. */
  export const formatCompactNumber = (n: number): string =>
    new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 }).format(n || 0);

  export const getUser = () => {
    const userString = localStorageService.getItem("user");

    let user: IUser = {
      _id: "",
      user_type: "",
      email: "",
      display_name: "",
      auth_type: "",
      website: "",
      is_email_verified: false,
    };

    if (userString) {
      user = JSON.parse(userString);
    }

    return user;
  };

  export const logout = (callback?: () => void) => {
    localStorageService.removeItem("user");
    localStorageService.removeItem("access_token");
    localStorageService.removeItem("capacities");
    localStorageService.removeItem("club");

    if (callback) {
      callback();
    }
  };

  export const canEditAddressForContacts = (sanctioningClub: string) => {
    return sanctioningClub === Constants.sanctioning_club.UKC
  };

  export const getStringValue = (
    primary: string | undefined,
    pre: any,
    key: string
  ): string => primary ?? pre?.[key] ?? "";

  export const getOptionValue = (
    primary: string | undefined,
    pre: any,
    defaultValue: IOption,
    valueKey: string,
    idKey?: string
  ): IOption => {
    return primary
      ? { value: primary, id: primary }
      : pre?.[valueKey]
        ? {
          value: pre[valueKey],
          id: idKey && pre[idKey] ? pre[idKey] : pre[valueKey],
        }
        : defaultValue;
  }
}
